import React, { useEffect, useState } from "react";
import Tabla from "./Tabla/index";
import TablaCorreos from "./TablaCorreos";
import icon_avisoprivacidad from "../../../assets/vw/svg/document.svg";
import icon_avisoprivacidad_active from "../../../assets/vw/svg/document-blue.svg";
import incon_arroba from "../../../assets/vw/svg/arroba.svg";
import incon_arroba_active from "../../../assets/vw/svg/arroba-azul.svg";
import Loading from "../../../components/Loading";
import Menu from "../../../components/Menu"
import Modal from "../../../components/Modal";
import NoInfoScreen from "../../../components/Screens/NoInfoScreen";

function SoporteAvisoPrivacidad(props) {
  const [dataAvisoPrivacidad, setDataAvisosPrivacidad] = useState([]);
  const [dataCorreosRebotados, setDataCorreosRebotados] = useState([])
  const [avisoPrivacidad, setAvisoPrivacidad] = useState([]);
  const [correoRebotado, setCorreoRebotado] = useState([]);
  const [cargando, setCargando] = useState(true);
  const [option, setOption] = useState("aviso");
  const [modal, setModal] = useState({
    active: false,
    message: '',
    success: false
  });

  const options = [
    {
      label: "Aviso de privacidad",
      icon: icon_avisoprivacidad,
      iconActive: icon_avisoprivacidad_active,
      value: "aviso"
    },
    {
      label: "Envio de correo",
      icon: incon_arroba,
      iconActive: incon_arroba_active,
      value: "envio"
    }
  ];

  async function getAvisoPrivacidad() {
    try {
      setCargando(true);
      setModal({
        active: false,
        message: '',
        success: false
      });
      const response = await fetch(
        process.env.REACT_APP_URL_DTO_AVP + "soporte?tipo=erroresSF",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error("Error en el feching de Aviso Privacidad" + data.mensaje);
      }

      setDataAvisosPrivacidad(data.mensaje);
      setCargando(false);
    } catch (error) {
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    }
  }

  async function getCorreosPrivacidad() {
    try {
      setCargando(true);
      setModal({
        active: false,
        message: '',
        success: false
      });
      const response = await fetch(
        process.env.REACT_APP_URL_DTO_AVP + "soporte?tipo=correosRebotados",
        {
          method: "GET",
          headers: {
            Authorization: "Bearer " + props.servicio.getToken(),
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();
      if (!response.ok) {
        throw new Error("Error en el feching de Aviso Privacidad" + data.mensaje);
      }

      setDataCorreosRebotados(data.mensaje)
      setCargando(false);
    } catch (error) {
      setCargando(false);
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    }

  }

  const handleChange = (e) => {
    setAvisoPrivacidad([])
    setCorreoRebotado([])
    if (option === "envio") {
      filtrarCorreos(e.target.value);
    } else {
      filtrar(e.target.value);
    }
  };

  const filtrar = (terminoBusqueda) => {
    const resultado = dataAvisoPrivacidad.filter((element) => {
      if (
        element.idCuentaContacto.toLowerCase().includes(terminoBusqueda.toLowerCase()) ||
        element.marca.toLowerCase().includes(terminoBusqueda.toLowerCase()) ||
        element.estadoCorreo.toLowerCase().includes(terminoBusqueda.toLowerCase()) ||
        element.estadoAceptacionUsuario.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setAvisoPrivacidad(resultado);
  };

  const filtrarCorreos = (terminoBusqueda) => {
    const resultado = dataCorreosRebotados.filter((element) => {
      if (
        element.idCuentaContacto.toLowerCase().includes(terminoBusqueda.toLowerCase()) ||
        element.marca.toLowerCase().includes(terminoBusqueda.toLowerCase())
      ) {
        return element;
      }
      return "";
    });
    setCorreoRebotado(resultado);
  };

  const changeOption = (option) => {
    setAvisoPrivacidad([]);
    setCorreoRebotado([]);
    setOption(option);
  };

  const recargarInfo = async () => {
    try {
      setCargando(true);
      setModal({ active: false, message: '', success: false });

      await Promise.all([
        getAvisoPrivacidad(),
        getCorreosPrivacidad(),
      ]);
    } catch (error) {
      setModal({
        active: true,
        message: error.message,
        success: false
      });
    } finally {
      setCargando(false);
    }
  };

  useEffect(() => {
    recargarInfo();
  }, []);  

  return (
    <>
      <Menu />
      <Modal modalInfo={modal} setMostrarModal={setModal} />
      {
        cargando && <Loading />
      }
      <div className={`navegacion`}>
        <div className=" posicionMenu">
          <ul className="d-flex flex-row px-0 my-0">
            {options.map((opt) => (
              <li
                key={opt.value}
                className="opcion-ruta normal_width"
                onClick={() => changeOption(opt.value)}
              >
                <div
                  className={`nav-link nav-link-title ps-0 mr-3 ${option === opt.value ? "active border_menu" : ""
                    }`}
                >
                  <img
                    src={option === opt.value ? opt.iconActive : opt.icon}
                    alt="accesos"
                    className="icono-menu me-3"
                  />
                  {opt.label}
                </div>
              </li>
            ))}
          </ul>
        </div>
        <div className="row border_vw pt-4 ms-0 mx-0">
          <div className="col-12 p-0 contenedor-table">
            {option === "envio" ? (
              <TablaCorreos
                servicio={props.servicio} correos={correoRebotado && correoRebotado.length > 0 ? correoRebotado : dataCorreosRebotados} handleChange={handleChange} onSuccessReenviar={recargarInfo}
              />
            ) : (
              <Tabla
                servicio={props.servicio} avisos={avisoPrivacidad && avisoPrivacidad.length > 0 ? avisoPrivacidad : dataAvisoPrivacidad} handleChange={handleChange} onSuccessReenviar={recargarInfo}
              />
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default SoporteAvisoPrivacidad;
